

interface SwitchProps {
  checked: boolean | number;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;                // optional label
  labelPosition?: "left" | "right"; // where to show the label
  className?: string;
}

export default function MySwitch({
  checked,
  onChange,
  disabled = false,
  label,
  labelPosition = "right",
  className = "",
}: SwitchProps) {
  const isOn = Boolean(checked);

  return (
    <div className="flex items-center gap-2">
      {/* Label on the LEFT */}
      {label && labelPosition === "left" && (
        <span className="text-[12px] select-none">{label}</span>
      )}

      {/* Switch */}
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && onChange(!isOn)}
        className={`
          relative inline-flex h-6 w-11 items-center rounded-full transition-all
          ${isOn ? "bg-blue-600" : "bg-gray-300"}
          ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}
          ${className}
        `}
      >
        <span
          className={`
            inline-block h-5 w-5 transform rounded-full bg-white transition-all
            ${isOn ? "translate-x-5" : "translate-x-1"}
          `}
        ></span>
      </button>

      {/* Label on the RIGHT */}
      {label && labelPosition === "right" && (
        <span className="text-[12px] select-none">{label}</span>
      )}
    </div>
  );
}